<template>
	<div>
		<van-field :value="value" style="display: none;"></van-field>

		<van-field :required="formCreateInject.rule.validate.required" readonly
			:label="formCreateInject.prop.title.title" v-model="timevalue" placeholder="" @click="show"
			input-align="right">
			<template #left-icon>
				<van-icon v-if="!disabled && !readonly" name="edit" color="#07c160" />
			</template>
		</van-field>
		<van-calendar :poppable="true" get-container="body" :min-date="getMinData()" :max-date="getMaxData()" :title="formCreateInject.prop.title.title"
			v-model="showPicker" :formatter="formatter" @confirm="confirm" />
	</div>
</template>
<style>
	.phoneCalendar_1 {
		color: black;
		font-weight: bold;
	}

	.phoneCalendar_2 {
		color: #F56C6C;
		font-weight: bold;
	}
</style>
<script>
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase],
		props: {
			type: {
				default: () => {
					return 'date'
				}
			},
			size: {
				default: () => {
					return 'mini'
				}
			},
			format: {
				default: () => {
					return 'date'
				}
			},
			valueFormat: {
				default: () => {
					return 'timestamp'
				}
			},
			prefixIcon: {
				default: () => {
					return 'none'
				}
			},
			unlinkPanels: {
				default: () => {
					return true
				}
			},
			schedulingText: {
				default: () => {
					return '已排期'
				}
			},
			title: {
				default: () => {
					return '请选择'
				}
			},
			maxNum: {
				default: () => {
					return 0
				}
			},
			schedulingtype: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				currentdata: new Date(),
				showPicker: false,
				timevalue: '',
				schedulingList: []
			}
		},
		created() {
			this.getMinData()

		},
		mounted() {

		},
		watch: {
			date(v) {
				
				this.change(v)
			},
			value(v) {
				if (!v) {
					this.timevalue = null
				}else{
					this.formatValue(v)
				}
			}
		},
		computed: {

		},
		methods: {
			show() {
				if (!this.disabled && !this.readonly) {
					this.getSchedulingList().then((res) => {
						this.schedulingList = res
						// if (this.value) {
						// 	this.timevalue = this.value
						// } else {
						// 	this.timevalue = this.formatValue(new Date())
						// }
						this.loading = false
						this.showPicker = true
					}, () => {
						this.showPicker = false
					})
				}
			},
			getSchedulingList() {
				return new Promise((resolve, reject) => {
					this.$api.scheduling.list({
						type: this.schedulingtype
					}).then((res) => {
						resolve(res)
					}, () => {
						reject()
					})

				})
			},
			formatter(day) {
				let year = day.date.getFullYear()
				let month = day.date.getMonth() + 1
				month = month < 9 ? '0' + month : month
				let date = day.date.getDate()
				date = date < 9 ? '0' + date : date
				let time = year + '-' + month + '-' + date
				//console.log(time)
				this.schedulingList.forEach((item) => {
					if (item.date == time) {
						day.bottomInfo = '排期:' + item.num
						day.className = item.num >= this.maxNum ? 'phoneCalendar_2' : 'phoneCalendar_1'
					}

				})

				// const month = day.date.getMonth() + 1;
				// const date = day.date.getDate();

				// if (month === 5) {
				// 	if (date === 1) {
				// 		day.topInfo = '劳动节';
				// 	} else if (date === 4) {
				// 		day.topInfo = '青年节';
				// 	} else if (date === 11) {
				// 		day.text = '今天';
				// 	}
				// }

				// if (day.type === 'start') {
				// 	day.bottomInfo = '入住';
				// } else if (day.type === 'end') {
				// 	day.bottomInfo = '离店';
				// }

				return day;
			},
			getMinData() {
				let currentDate = new Date()
				let currentYear = currentDate.getFullYear()
				let tenYearsAgoYear = currentYear - 5
				return new Date(tenYearsAgoYear, currentDate.getMonth(), currentDate.getDate())
			},
			getMaxData() {
				let currentDate = new Date()
				let currentYear = currentDate.getFullYear()
				let tenYearsAgoYear = currentYear + 5
				return new Date(tenYearsAgoYear, currentDate.getMonth(), currentDate.getDate())
			},
			confirm(val) {
				let postvalue = this.formatValue(val)
				this.$emit('input', postvalue)
				this.$emit('change', postvalue)
				this.showPicker = false
			},
			formatValue(val) {
				let postvalue = null
				let postarr = []
				let showarr = []
				if (val) {
					if (Array.isArray(val)) {
						val.forEach((item) => {
							postarr.push(Date.parse(item) / 1000)
							showarr.push(window.systemMethods.timestampToDate(new Date(item).getTime(), this
								.format ==
								'date' ?
								true : false))
						})
						postvalue = postarr.join(',')
						this.timevalue = showarr.join('-')
					} else {
						postvalue = Date.parse(val) / 1000
						this.timevalue = window.systemMethods.timestampToDate(new Date(val).getTime(), this.format ==
							'date' ?
							true : false)
					}
				}

				return postvalue
			}
		}
	}
</script>